import Vue from 'vue'
import Router from 'vue-router'
import { Message,Loading  } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
NProgress.configure({ showSpinner: false })// NProgress Configuration

Vue.use(Router)

// 导出基础路由
import baseRouter from './modules/base.js';
// import crmRouter from './modules/crm.js';

let router =  new Router({
	// mode : 'history',
	mode : 'hash',
	scrollBehavior: () => ({ y: 0 }),
	linkExactActiveClass :'is-active',
	routes: [...baseRouter]
});

let loading = null;

router.beforeEach((to, from, next) => {
	loading = Loading.service({
		lock: true,
		text: '正在加载页面...',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	
	NProgress.start() // start progress bar
	
	if (to.meta.title) {
	 	document.title = to.meta.title
	}
	
	next();
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
  loading.close();
})


export default router;




// WEBPACK FOOTER //
// ./src/router/index.js